Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.WebchatMessage extends Backbone.Model

  constructor: (message) ->
    @message = message
    @attachmentsManager = new Customer.Methods.WebchatAttachmentsManager(@message.files)

  getJson: ->
    @message

  getGroupType: ->
    "webchat"

  getType: ->
    "webchat"

  getSubType: ->
    "webchat-message"

  getPrivacy: ->
    'private'

  getContentId: ->
    @message.content_id

  isBrandContent: ->
    (@message.is_brand_content == true) || (@message.is_brand_content == 'true')

  hasUser: ->
    true

  hasProfile: ->
    true

  hasRelated: ->
    false

  getAuthorId: ->
    @message.session.id

  getAuthorName: ->
    if @isBrandContent()
      @message.channel_text
    else
      @message.author.name

  getAvatar: ->
    if @isBrandContent()
      @message.channel_avatar
    else
      window.image_path(@getSubType() + '.png')
  
  getChannelText: ->
    if @isBrandContent()
      @message.channel_text
    else
      ''

  getCreatedAt: ->
    moment(parseInt(@message.created_at)).format('YYYY-MM-DD HH:mm:ss.SSS Z')

  getMainText: ->
    @message.text || ''

  getCustomFields: ->
    @message.custom_fields

  getCustomFieldsAsString: ->
    _.map(@getCustomFields(), (value, key) =>
      "#{key}: #{value}"
    ).join(" - ")

  hasAttachments: ->
    @attachmentsManager.hasAttachments()

  getAttachments: (att_type) ->
    @attachmentsManager.getAttachments(att_type)

  hasQuickReplies: ->
    @message.quick_replies_menu && @message.quick_replies_menu.length > 0

  getQuickReplies: ->
    @message.quick_replies_menu

  hasShares: ->
    false

  getShares: ->
    []

  getAuthorUsername: ->
    ''


  type: ->
    @getType()

  getValue: (name) ->
    return @getValues()[name]
    
  getValues: ->
    return @get('data').content
